export const environment = {
  production: true,
  url: 'https://api-dot-datalive-defect-report-staging.appspot.com',
  urlFMT: 'https://dashboard.datalive-staging.com/api',
  ssoAuthUrl: 'https://defect.datalive-staging.com/oauth2/',
  authUrl: 'https://auth.datalive-staging.com/',
  appReference: 'DEFECT',
  dataliveUrl: 'https://dashboard.datalive-staging.com',
  refreshTokenUrl: "https://datalive-staging.nw.r.appspot.com/oauth2/refresh/", // Staging
  oauthCookieDomain: '.datalive-staging.com',
  developmentAccessToken: null
};
